import Vue from 'vue';
import axios from 'axios';
import {
  MessageBox,
  Message,
} from 'element-ui';
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let rawAuthority = localStorage.getItem('authority');
let authority = rawAuthority && JSON.parse(rawAuthority) || {};

const token = authority && (authority.tokenType + authority.token);
console.log(token);
const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control,
  headers: {
    Authorization: token,
  },
};

const _axios = axios.create(config);

// const _otherAxiosIstance = axios.create({
//   baseURL: process.env.VUE_APP_API_URL
// })
_axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    if (!token) {
      rawAuthority = localStorage.getItem('authority');
      authority = rawAuthority && JSON.parse(rawAuthority) || {};
      const token = authority && (authority.tokenType + authority.token);
      config.headers.Authorization = token;
    }
    return config;
  },

  error =>
  // Do something with request error
  Promise.reject(error),
);

// Add a response interceptor
_axios.interceptors.response.use(
  response =>
  // Do something with response data
  response,
  (error) => {
    // Do something with response error
    if (error.response) {
      switch (error.response.status) {
        case 400:
          break;
        case 401:
          // localStorage.clear();
          localStorage.removeItem('authority');
          localStorage.removeItem('currentUser');
          console.log(MessageBox);
          MessageBox.alert('您的登录信息已过期，也可能是您的账号在别的设备登录，请重新登录！', '登录信息失效', {
            confirmButtonText: '确定',
            callback: (action) => {
              location.href = '/login';
            },

          });
          break;
        case 422:
          return Promise.reject(error.response);
          // return Promise.reject(error);
        default:
          return Promise.reject(error.response);
      }
    }
    return Promise.reject(error);
  },
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export {
  _axios as
  default,
};
